import moment from 'moment';

export const getLocalTimeFromUTC = (
  date: string,
  format = 'YYYY-MM-DD hh:mm'
) => {
  const local = moment.utc(date).local().locale('en').format(format);

  return local;
};
